(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["trouve-ta-taille"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__ttfReady) return; window.__ttfReady=1;

  /* ============================================================
     REGLES DE TAILLE - GRILLE FOURNISSEUR
     Tableau d'origine en jin chinois (1 jin = 0,5 kg), converti ici.
       S   cou 32-49 cm   poitrail 34-63 cm   4 a 7,5 kg
       M   cou 38-60 cm   poitrail 38-75 cm   7,5 a 17,5 kg
       L   cou 42-66 cm   poitrail 38-89 cm   17,5 a 22,5 kg
       XL  cou 52-85 cm   poitrail 48-98 cm   22,5 a 45 kg
     La morphologie et la race ajustent un "poids effectif" :
     la taille ne bascule que si ce poids franchit une borne.
     ============================================================ */
  var GRILLE=[
    {t:'S', max:7.5,  cou:'32-49 cm', poi:'34-63 cm'},
    {t:'M', max:17.5, cou:'38-60 cm', poi:'38-75 cm'},
    {t:'L', max:22.5, cou:'42-66 cm', poi:'38-89 cm'},
    {t:'XL',max:45,   cou:'52-85 cm', poi:'48-98 cm'}
  ];
  var COEF={fin:0.93,normal:1,trapu:1.08,rond:1.12};
  var LARGE='bouledogue,bulldog,carlin,boston,staffordshire,bully,pitbull,boxer,cane corso,shar,dogue,rottweiler,beagle,basset,chow,mastiff,terre-neuve,saint-bernard';
  var ETROIT='levrier,whippet,greyhound,barzoi,saluki,galgo,teckel,pinscher,podenco';

  function indexPour(kg){
    for(var i=0;i<GRILLE.length;i++){ if(kg<=GRILLE[i].max) return i }
    return GRILLE.length-1;
  }

  function recommanderTaille(race,poids,morpho){
    var r=norm(race||''), coef=COEF[morpho]||1, note;
    if(LARGE.split(',').some(function(k){return r.indexOf(k)>-1})) coef*=1.07;
    if(ETROIT.split(',').some(function(k){return r.indexOf(k)>-1})) coef*=0.94;

    var base=indexPour(poids), i=indexPour(poids*coef);

    if(poids<4){
      i=0;
      note="C'est la plus petite taille du harnais. Les sangles se resserrent au maximum pour s'ajuster aux tout petits gabarits.";
    } else if(poids>45){
      i=GRILLE.length-1;
      note="Ton chien dépasse la plage couverte par ce harnais. Mesure son tour de poitrail : la XL monte jusqu'à 98 cm.";
    } else if(i>base){
      note="Sa morphologie élargit son tour de poitrail, on passe donc à la taille au-dessus. Un harnais un peu large se resserre avec les sangles, l'inverse non.";
    } else if(i<base){
      note="Sa silhouette fine réduit son tour de poitrail : la taille en dessous tiendra mieux, sans flotter aux épaules.";
    } else {
      note="C'est la taille qui offrira le meilleur maintien pour son gabarit. Les sangles se règlent ensuite pour affiner l'ajustement.";
    }

    var g=GRILLE[i];
    return {
      taille:g.t,
      titre:'La taille '+g.t+' est faite pour lui',
      note:note,
      mesures:'Tour de cou '+g.cou+'   -   Tour de poitrail '+g.poi
    };
  }
  /* ==================== FIN DES REGLES ======================== */

  var LBL={fin:'Fin / elance',normal:'Normal',trapu:'Trapu / muscle',rond:'Rond / rondelet'};
  var opener=null;

  function q(m,s){return m.querySelector(s)}
  function step(m){return parseInt(m.getAttribute('data-ttf-step'),10)||1}

  function show(m,n){
    m.setAttribute('data-ttf-step',n);
    m.querySelectorAll('[data-ttf-q]').forEach(function(el){
      el.hidden=(el.getAttribute('data-ttf-q')!=String(n));
    });
    q(m,'.ttf-nav').hidden=(n===4);
    q(m,'[data-ttf-back]').hidden=(n===1||n===4);
    if(n<4){
      q(m,'[data-ttf-counter]').textContent='Étape '+n+' sur 3';
      q(m,'[data-ttf-fill]').style.width=(n*33.34)+'%';
    }
    q(m,'[data-ttf-error]').classList.remove('ttf-on');
    hideSug(m);
    q(m,'.ttf-pn').scrollTop=0;
    var f=m.querySelector('[data-ttf-q="'+n+'"] input:not([type=radio])');
    if(f)setTimeout(function(){f.focus()},80);
  }

  function fail(m,msg){var e=q(m,'[data-ttf-error]');e.textContent=msg;e.classList.add('ttf-on')}

  /* ---------- Suggestions de race ---------- */
  function norm(s){s=s.normalize('NFD');var o='',i,c;for(i=0;i<s.length;i++){c=s.charCodeAt(i);if(c<768||c>879)o+=s.charAt(i)}return o.toLowerCase()}
  function hideSug(m){var b=m&&q(m,'[data-ttf-sg]');if(b)b.hidden=true}

  function suggest(inp){
    var m=inp.closest('.ttf-md'), box=q(m,'[data-ttf-sg]'), v=inp.value.trim();
    box.innerHTML='';
    if(!v){box.hidden=true;return}
    var list=(inp.getAttribute('data-ttf-breeds')||'').split(',').map(function(x){return x.trim()}).filter(Boolean),
        n=norm(v), starts=[], has=[];
    list.forEach(function(b){
      var nb=norm(b);
      if(nb.indexOf(n)===0)starts.push(b); else if(nb.indexOf(n)>-1)has.push(b);
    });
    var res=starts.concat(has).slice(0,6);
    if(!res.length||(res.length===1&&norm(res[0])===n)){box.hidden=true;return}
    res.forEach(function(b){
      var li=document.createElement('li'), btn=document.createElement('button'), i=norm(b).indexOf(n);
      btn.type='button'; btn.setAttribute('data-ttf-pick','');
      if(i>-1){
        btn.appendChild(document.createTextNode(b.slice(0,i)));
        var mk=document.createElement('mark'); mk.textContent=b.slice(i,i+v.length); btn.appendChild(mk);
        btn.appendChild(document.createTextNode(b.slice(i+v.length)));
      } else btn.textContent=b;
      li.appendChild(btn); box.appendChild(li);
    });
    box.hidden=false;
  }

  function pickSug(btn){
    var m=btn.closest('.ttf-md'), inp=q(m,'[data-ttf-race]');
    inp.value=btn.textContent; hideSug(m); inp.focus();
  }

  function navSug(m,dir){
    var box=q(m,'[data-ttf-sg]');
    if(!box||box.hidden)return false;
    var btns=box.querySelectorAll('button');
    if(!btns.length)return false;
    var cur=-1;
    btns.forEach(function(b,i){if(b.classList.contains('ttf-hi'))cur=i});
    if(cur>-1)btns[cur].classList.remove('ttf-hi');
    var nx=cur+dir;
    if(nx<0)nx=btns.length-1;
    if(nx>=btns.length)nx=0;
    btns[nx].classList.add('ttf-hi');
    btns[nx].scrollIntoView({block:'nearest'});
    return true;
  }

  function openM(m){
    if(m.parentNode!==document.body)document.body.appendChild(m);
    m.hidden=false;
    document.documentElement.classList.add('ttf-lock');
    show(m,1);
  }
  function closeM(m){
    m.hidden=true;
    document.documentElement.classList.remove('ttf-lock');
    if(opener&&opener.focus)opener.focus();
  }

  function advance(m){
    var f=q(m,'[data-ttf-form]'), s=step(m);
    q(m,'[data-ttf-error]').classList.remove('ttf-on');
    if(s===1){
      if(!f.race.value.trim()){fail(m,"Indique la race de ton chien, ou écris « croisé ».");return}
      return show(m,2);
    }
    if(s===2){
      var pv=f.poids.value.trim(), p=parseFloat(pv.replace(',','.'));
      if(!pv||isNaN(p)||p<=0){fail(m,'Indique le poids de ton chien en kilos.');return}
      return show(m,3);
    }
    if(!f.querySelector('input[name="morpho"]:checked')){fail(m,'Choisis la morphologie de ton chien.');return}
    finish(m);
  }

  function finish(m){
    var f=q(m,'[data-ttf-form]'),
        race=f.race.value.trim(),
        poids=parseFloat(f.poids.value.trim().replace(',','.')),
        morpho=f.querySelector('input[name="morpho"]:checked').value,
        r=recommanderTaille(race,poids,morpho)||{};
    q(m,'[data-ttf-size]').textContent=r.taille||'-';
    q(m,'[data-ttf-headline]').textContent=r.titre||'';
    q(m,'[data-ttf-note]').textContent=r.note||'';
    q(m,'[data-ttf-mesures]').textContent=r.mesures||'';
    var rc=q(m,'[data-ttf-recap]'); rc.innerHTML='';
    [race,poids+' kg',LBL[morpho]||morpho].forEach(function(t){
      var s=document.createElement('span'); s.textContent=t; rc.appendChild(s);
    });
    m.setAttribute('data-ttf-size',r.taille||'');
    show(m,4);
  }

  function pick(m){
    var size=m.getAttribute('data-ttf-size');
    closeM(m);
    if(!size)return;
    var done=false, s=size.toLowerCase();
    document.querySelectorAll('form[action*="/cart/add"] select').forEach(function(sel){
      Array.prototype.forEach.call(sel.options,function(o){
        if(!done&&o.value.trim().toLowerCase()===s){sel.value=o.value;sel.dispatchEvent(new Event('change',{bubbles:true}));done=true}
      });
    });
    if(!done)document.querySelectorAll('form[action*="/cart/add"] input[type="radio"]').forEach(function(rd){
      if(!done&&rd.value.trim().toLowerCase()===s){rd.checked=true;rd.dispatchEvent(new Event('change',{bubbles:true}));done=true}
    });
    var atc=document.querySelector('form[action*="/cart/add"]');
    if(atc)atc.scrollIntoView({behavior:'smooth',block:'center'});
  }

  document.addEventListener('input',function(e){
    if(e.target.matches('[data-ttf-race]'))suggest(e.target);
  });

  document.addEventListener('click',function(e){
    var pk=e.target.closest('[data-ttf-pick]');
    if(pk)return pickSug(pk);

    var t=e.target.closest('[data-ttf-open]');
    if(t){
      var m=document.getElementById('ttfm-'+t.getAttribute('data-ttf-open'));
      if(m){opener=t;openM(m)}
      return;
    }
    if(!e.target.closest('[data-ttf-race]'))hideSug(document.querySelector('.ttf-md:not([hidden])'));

    var el=e.target.closest('.ttf-md [data-ttf-close],.ttf-md [data-ttf-next],.ttf-md [data-ttf-back],.ttf-md [data-ttf-restart],.ttf-md [data-ttf-cta]');
    if(!el)return;
    var m=el.closest('.ttf-md');
    if(el.hasAttribute('data-ttf-close'))return closeM(m);
    if(el.hasAttribute('data-ttf-next'))return advance(m);
    if(el.hasAttribute('data-ttf-back')){var s=step(m);if(s>1)show(m,s-1);return}
    if(el.hasAttribute('data-ttf-restart')){q(m,'[data-ttf-form]').reset();return show(m,1)}
    if(el.hasAttribute('data-ttf-cta'))return pick(m);
  });

  document.addEventListener('change',function(e){
    if(!e.target.matches('.ttf-md input[name="morpho"]'))return;
    var m=e.target.closest('.ttf-md');
    setTimeout(function(){finish(m)},180);
  });

  document.addEventListener('keydown',function(e){
    var m=document.querySelector('.ttf-md:not([hidden])');
    if(!m)return;
    var box=q(m,'[data-ttf-sg]'), openList=box&&!box.hidden;
    if(e.key==='Escape'){
      if(openList){hideSug(m);return}
      return closeM(m);
    }
    if(e.key==='ArrowDown'||e.key==='ArrowUp'){
      if(navSug(m,e.key==='ArrowDown'?1:-1))e.preventDefault();
      return;
    }
    if(e.key==='Enter'&&step(m)<4){
      e.preventDefault();
      var hi=openList?box.querySelector('button.ttf-hi'):null;
      if(hi)return pickSug(hi);
      hideSug(m);
      advance(m);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
